import { useMemo } from "react";
import { useDealStatusSelector } from "store";
import { IStatus } from "store/types";

const reportedDealStatusNames = ["Invested", "Closed"];

export const useIsReportDeal = (dealStatusName?: IStatus["name"]): boolean => {
  const dealStatus = useDealStatusSelector();

  return useMemo(() => {
    if (!dealStatusName && !dealStatus) return false;

    // Priority of the argument higher than context
    if (dealStatusName) return reportedDealStatusNames.includes(dealStatusName);

    if (dealStatus) return reportedDealStatusNames.includes(dealStatus.name);

    // Deal is not available for report by default
    return false;
  }, [dealStatusName, dealStatus]);
};
